import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { SpinnerComponent } from '@adaptiva/widgets/spinner';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OidcRegisterComponent } from './oidc-register.component';

@NgModule({
	imports: [
		AlertComponentModule,
		CommonModule,
		RouterModule.forChild([{
			path: '',
			component: OidcRegisterComponent
		}]),
		SpinnerComponent
	],
	declarations: [OidcRegisterComponent],
	exports: [OidcRegisterComponent]
})
export class OidcRegisterModule {

}
